import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccessibilityStatementComponent } from './components/accessibility-statement/accessibility-statement.component';
import { ConnexionComponent } from './components/connexion/connexion.component';
import { DeconnexionComponent } from './components/deconnexion/deconnexion.component';
import { GuardService } from './guards/guard.service';
import { HabilitationCLGuard } from './guards/habilitation-cl.guard';
import { HomeComponent } from './components/home/home.component';
import { PageInMaintenanceComponent } from './components/page-in-maintenance/page-in-maintenance.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [GuardService],
  },
  {
    path: 'habilitation',
    loadChildren: () => import('./habilitation/habilitation.module').then(m => m.HabilitationModule),
    canActivate: [GuardService, HabilitationCLGuard],
  },
  {
    path: 'contrat',
    loadChildren: () => import('./contrats/contrat.module').then((m) => m.ContratModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [GuardService],
  },
  {
    path: 'declaration-accessibilite',
    component: AccessibilityStatementComponent,
  },
  {
    path: 'maintenance',
    component: PageInMaintenanceComponent,
  },
  {
    path: 'error',
    component: PageNotFoundComponent,
  },
  {
    path: 'login',
    component: ConnexionComponent,
  },
  {
    path: 'deconnexion',
    component: DeconnexionComponent,
  },
  {
    path: 'psc',
    redirectTo: '/login?psc=true',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [GuardService],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
